import React, { useCallback } from 'react';

import { IContract, IProject, useProjectTreeStore } from 'store/projectContract.store';

import { ConfirmDeleteProjectModal } from 'components/common/ProgramLibraryDropdownMenu/components/ConfirmDeleteProjectModal/ConfirmDeleteProjectModal';
import { ConfirmDeleteSubProgramModal } from 'components/common/ProgramLibraryDropdownMenu/components/ConfirmDeleteSubProgramModal/ConfirmDeleteSubProgramModal';
import { ConfirmRefreshProjectModal } from 'components/common/ProgramLibraryDropdownMenu/components/ConfirmRefreshProjectModal/ConfirmRefreshProjectModal';
import { ConfirmRefreshSubProgramModal } from 'components/common/ProgramLibraryDropdownMenu/components/ConfirmRefreshSubProgramModal/ConfirmRefreshSubProgramModal';
import { RenameProjectModal } from 'components/common/ProgramLibraryDropdownMenu/components/RenameProjectModal/RenameProjectModal';
import { RenameSubProgramModal } from 'components/common/ProgramLibraryDropdownMenu/components/RenameSubProgramModal/RenameSubProgramModal';

export const ModalManger = React.memo(
    ({ callback }: { callback?: (project: IProject | null, contract: IContract | null) => void }) => {
        const { modalType, update } = useProjectTreeStore();

        const handleModalClose = useCallback(() => {
            update({ modalType: null });
        }, []);

        return (
            <>
                <ConfirmDeleteSubProgramModal
                    handleModalClose={handleModalClose}
                    isShowModal={modalType === 'DELETE_SUB_PROGRAM'}
                    callback={callback}
                />

                <ConfirmDeleteProjectModal
                    handleModalClose={handleModalClose}
                    isShowModal={modalType === 'DELETE_PROJECT'}
                    callback={callback}
                />

                <ConfirmRefreshSubProgramModal
                    handleModalClose={handleModalClose}
                    isShowModal={modalType === 'REFRESH_SUB_PROGRAM'}
                />

                <ConfirmRefreshProjectModal
                    handleModalClose={handleModalClose}
                    isShowModal={modalType === 'REFRESH_PROJECT'}
                />
                <RenameProjectModal onHideModal={handleModalClose} showModal={modalType === 'RENAME_PROJECT'} />
                <RenameSubProgramModal onHideModal={handleModalClose} showModal={modalType === 'RENAME_SUB_PROGRAM'} />
            </>
        );
    },
);
